import Cookies from 'js-cookie';

class SignupService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.SIGNUP = '/api/signup';
        this.VERIFY = '/api/verify';
        this.GENERATE = '/api/generate';
        this.GET_USER_BY_USERNAME = '/user/username/{username}';
        this.GET_USER_BY_EMAIL= '/user/email/{email}';
    }
    
    async getUserByUsernameForSignup(username) {
        try {
            let url = window.location.origin + this.SIGNUP + this.GET_USER_BY_USERNAME;
            url = url
                .replace('{username}', username)
            return this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(response => response.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'User Not Found')
                            return data;
                    }
                    return data;
                });
        } catch(err) {
            console.log(err);
        }
   }

    async getUserByEmailForSignup(email) {
        try {
            let url = window.location.origin + this.SIGNUP + this.GET_USER_BY_EMAIL;
            url = url
                .replace('{email}', email)
            return this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(response => response.json());
        }
        catch(err) {
            console.log(err);
        }
    }

    async signupUser(signupUserData){
        try{
            let url = window.location.origin + this.SIGNUP;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(signupUserData)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        localStorage.setItem('errorUUID', data.uuid);
                    }
                    return data;
                });
        }
        catch(err){
            console.log(err);
        }
    }

    async generateEmailVerificationCode(toEmail){
        try{
            let url = window.location.origin + this.SIGNUP + this.GENERATE ;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: toEmail
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        localStorage.setItem('errorUUID', data.uuid);
                    }
                    return data;
                });
        }
        catch(err){
            console.log(err);
        }
    }

    async verifyEmailVerificationCode(verificationCodeMap){
        try{
            let url = window.location.origin + this.SIGNUP + this.VERIFY;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(verificationCodeMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        localStorage.setItem('errorUUID', data.uuid);
                    }
                    return data;
                });
        }
        catch(err){
            console.log(err);
        }
    }
}

export default SignupService;
